module.exports = __webpack_public_path__ + "static/media/9.f079ff89.jpeg";